module.exports = __webpack_public_path__ + "img/vw.b101543f.png";